/**
 * Guess you like
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:15:25
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:15:25
 */

'use client'

// import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'
import { GuessYouLikeGrid } from '@comp/page/search/common/guess-you-like'
import useTracking from '@hook/useTracking'
import { houseToGta, isAU } from '@lib/utils'
import { isArray } from 'lodash-es'
import { useTranslations } from 'next-intl'
import PropertyItemScoff from '../PropertyItemScoff'

function HomelyTracking({ data }) {
  const [fired, setFired] = useState(false)
  const { pushTrack } = useTracking()

  if(isAU && !fired && isArray(data) && data.length > 0) {
    setFired(true)
    pushTrack(
      'homely_similar_props_card_view',
      houseToGta(data, undefined, 'search_result')
    )
  }
}

export default function GuestYouLike({ house }) {
  const th = useTranslations('house')
  const { pushTrackListingClick } = useTracking()

  const customProps = useMemo(() => ({
    onListingCardClick: () => pushTrackListingClick('you_may_like-other_house', house)
  }), [house, pushTrackListingClick])

  return (
    <PropertyItemScoff 
      title={th('guessYouLike')}
      moduleName={th('guessYouLike')}
      id="module-guessYouLike"
    >
      <GuessYouLikeGrid customProps={customProps}>
        {HomelyTracking}
      </GuessYouLikeGrid>
    </PropertyItemScoff>
  )
}

// GuestYouLike.propTypes = {
//   className: PropTypes.string,
// }
